import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { CodesmithIcon } from "./CodesmithIcon";
interface CodesmithLottieIconProps {
  className?: string;
  // Drives the animation. Defaults to false so the icon is a static glyph
  // wherever it mounts; the rail flips it true only while the Codesmith row is
  // hovered so the perpetual rAF loop never runs at rest.
  play?: boolean;
}
const CodesmithLottieIconClient = dynamic(() => import("./CodesmithLottieIconClient"), {
  ssr: false,
  loading: () => <CodesmithIcon />
});
export function CodesmithLottieIcon(t0) {
  const $ = _c(3);
  const {
    className,
    play: t1
  } = t0;
  const play = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className || $[1] !== play) {
    t2 = <CodesmithLottieIconClient className={className} play={play} />;
    $[0] = className;
    $[1] = play;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}